const initialState = {
  listAnswersWordcloud: [],
  trash: {
    actions: {
      items: [],
      documents: 0,
    },
  },
};

export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/answers/initialState.js